import React, { PureComponent } from 'react';
import Request from "../../networkReq/request";
import Http from "../../networkReq/http"
import "./index.scss";

import banner from 'images/preferential/banner.png';
import { Link } from 'react-router-dom';

export default class Preferential extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            index: 0,
            infoList: [],

        }

    }

    componentDidMount() {
        this.getArticleBannerList()
    }


    getArticleBannerList(type, size) {
        return Http.get(Request.getArticleBannerList(), {}, obj => {
            console.log('obj', obj);
            if (obj && obj.code == 200) {
                this.setState({
                    infoList: obj.data
                })
            }
        });
    }


    render() {
        let { infoList } = this.state;
        return (
            <div>
                {/* banner */}
                {/* <div className="banner">
                    <div className="container">
                        <img src={banner} alt='' />
                    </div>
                </div> */}
                {/* banner */}
                {/* 按钮跳转 */}
                <div className="links">
                    <div className="container">
                        <a href='/preferential/application' className="link">
                            <div className="link_title">优抚申请</div>
                            <div className="link_txt">伤残军人、三红、三属、在乡老复员军人、带病回乡退伍军人、参战退役军人等优抚服务申请</div>
                        </a>
                        <a href='/preferential/search' className="link">
                            <div className="link_title">优抚查询</div>
                            <div className="link_txt">伤残军人、三红、三属、在乡老复员军人、带病回乡退伍军人、参战退役军人等优抚服务申请</div>
                        </a>
                    </div>
                </div>
                {/* 按钮跳转 */}
                {/* 优抚资讯 */}
                <div className="message">
                    <div className="container">
                        <div className="title_box">
                            <div className="title">优抚资讯</div>
                            <a href="/preferential/preferentialInfo" className="more">更多 >></a>
                        </div>
                        <div className="cont clear">
                            <div className="cont_img_box">
                                {infoList.zxBanner && infoList.zxBanner.slice(0, 5).map((item, index) => (
                                    <a href="#" key={index}>
                                        <img
                                            src={item.bannerUrl}
                                            alt=''
                                        />
                                    </a>
                                ))}
                            </div>
                            <div className="cont_list">
                                <ul>
                                    {infoList.zxList && infoList.zxList.length > 0 ? infoList.zxList.slice(0, 7).map((item, index) => {
                                        console.log("item:", item)
                                        return (
                                            <li key={index}>
                                                <a href={'/preferential/preferentialInformationDetail?' + item.id}>
                                                    <div className="cont_list_dot"></div>
                                                    <div className="cont_list_txt" style={{ width: '70%' }}>{item.title}</div>
                                                    <div className="cont_list_time">{item.createTime.slice(0, 10)}</div>
                                                </a>
                                            </li>
                                        )
                                    }) : null
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="message" style={{ marginBottom: '40px' }}>
                    <div className="container">
                        <div className="title_box">
                            <div className="title">优抚政策</div>
                            <a href="/preferential/preferentialPolicy" className="more">更多 >></a>
                        </div>
                        <div className="cont clear">
                            <div className="cont_list_next">
                                <div className="cont_list_next_img_box">
                                    <img src={infoList.zcBanner ? infoList.zcBanner[0].bannerUrl : ''} />
                                </div>
                                <ul className="cont_list_ul">
                                    {infoList.zcList && infoList.zcList.length > 0 ? infoList.zcList.slice(0, 6).map((item, index) => {
                                        return (
                                            <li>
                                                <a href={'/preferential/preferentialPolicyDetail?' + item.id}>
                                                    <div className="cont_list_dot_next"></div>
                                                    <div className="cont_list_txt_next">{item.title}</div>
                                                    <div className="cont_list_time">{item.createTime.slice(0, 10)}</div>
                                                </a>
                                            </li>
                                        )
                                    }) : null
                                    }
                                </ul>
                            </div>
                            <div className="cont_list_next" style={{ float: 'right' }}>
                                <div className="cont_list_next_img_box">
                                    <img src={infoList.zcBanner ? infoList.zcBanner[1].bannerUrl : ''} />
                                </div>
                                <ul className="cont_list_ul">
                                    {infoList.zcList && infoList.zcList.length > 0 ? infoList.zcList.slice(6, 12).map((item, index) => {
                                        return (
                                            <li>
                                                <a href={'/preferential/preferentialPolicyDetail?' + item.id}>
                                                    <div className="cont_list_dot_next"></div>
                                                    <div className="cont_list_txt_next">{item.title}</div>
                                                    <div className="cont_list_time">{item.createTime.slice(0, 10)}</div>
                                                </a>
                                            </li>
                                        )
                                    }) : null
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                {/* 优抚资讯 */}

            </div>
        )
    }
}